import { render } from "./Form.vue?vue&type=template&id=a2877920&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=a2877920&lang=scss"
import "./Form.vue?vue&type=style&index=1&id=a2877920&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2877920"]])

export default __exports__